import { api } from './api.js';

const COGNITO_DOMAIN = import.meta.env.VITE_COGNITO_DOMAIN || 'auth.mathee.us';
const CLIENT_ID = import.meta.env.VITE_COGNITO_CLIENT_ID || '';
const REDIRECT = import.meta.env.VITE_COGNITO_REDIRECT || 'https://mathee.us/auth/callback';

function base64UrlEncode(buffer) {
  let str = '';
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < bytes.byteLength; i++) {
    str += String.fromCharCode(bytes[i]);
  }
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

async function gerarPkce() {
  const verifier = base64UrlEncode(crypto.getRandomValues(new Uint8Array(32)));
  const hash = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  const challenge = base64UrlEncode(hash);
  return { verifier, challenge };
}

export async function iniciarLogin() {
  const { verifier, challenge } = await gerarPkce();
  const state = base64UrlEncode(crypto.getRandomValues(new Uint8Array(16)));
  sessionStorage.setItem('pkce_verifier', verifier);
  sessionStorage.setItem('oauth_state', state);

  const params = new URLSearchParams({
    response_type: 'code',
    client_id: CLIENT_ID,
    redirect_uri: REDIRECT,
    scope: 'openid email profile',
    state,
    code_challenge: challenge,
    code_challenge_method: 'S256',
    lang: 'pt-BR',
  });
  window.location.assign(`https://${COGNITO_DOMAIN}/login?${params.toString()}`);
}

export async function trocarCodePorSessao(code, state) {
  const esperado = sessionStorage.getItem('oauth_state');
  if (!state || state !== esperado) throw new Error('state_invalido');
  const verifier = sessionStorage.getItem('pkce_verifier');
  sessionStorage.removeItem('pkce_verifier');
  sessionStorage.removeItem('oauth_state');
  await api.authCallback(code, verifier);
}

export async function logout() {
  try {
    await api.authLogout();
  } catch {
    // ignora
  }
  const params = new URLSearchParams({
    client_id: CLIENT_ID,
    logout_uri: 'https://mathee.us/',
  });
  window.location.assign(`https://${COGNITO_DOMAIN}/logout?${params.toString()}`);
}
